import { fetchCarHireOfferList } from 'actions/CarHireActions'
import { getCarHireListKey } from 'components/CarHire/carHireUtils'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

const EmptyList: App.CarHireList = {
  fetching: true,
  timestamp: 0,
  pickUp: { date: '', dateChanged: false },
  dropOff: { date: '', dateChanged: false },
  vehicles: [],
}

function useCarHireList(filters: App.CarHireOfferListFilters, expired: number) {
  const dispatch = useAppDispatch()
  const listKey = useMemo(() => {
    return getCarHireListKey(filters)
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, expired])

  const list = useAppSelector(state => state.carHire.offerLists[listKey]) ?? EmptyList

  useEffect(() => {
    const { pickUpDate, dropOffDate, dropOffTime, pickUpTime, pickUpLocationId } = filters
    if (pickUpLocationId && pickUpTime && dropOffTime && dropOffDate && pickUpDate && pickUpTime) {
      dispatch(fetchCarHireOfferList(filters))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [listKey, expired])

  return list
}

export default useCarHireList
